import { render } from "./ParamssArrayItem.vue?vue&type=template&id=a71ac468"
import script from "./ParamssArrayItem.vue?vue&type=script&lang=js"
export * from "./ParamssArrayItem.vue?vue&type=script&lang=js"

import "./ParamssArrayItem.vue?vue&type=style&index=0&id=a71ac468&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__